import './index.styles.css'
interface Props {
  circleColor?: string
  circleWidth?: string
  value: number
  valueCircleColor: string
  showScore?: boolean
  valueText?: string
}

const Chart = ({
  circleColor = '#F2F4F5',
  circleWidth = '3',
  value = 0,
  valueCircleColor = '#F2F4F5',
  showScore = false,
  valueText
}: Props) => {
  const text = valueText ? valueText : `${value}%`
  return (
    <div style={{ width: '80px' }}>
      <svg
        viewBox="0 0 36 36"
        style={{
          overflow: 'visible',
          maxHeight: '80px'
        }}
      >
        <path
          fill="none"
          stroke={circleColor}
          strokeWidth={circleWidth}
          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        {!!value && (
          <path
            className={'Chart_circleAnimation'}
            fill="none"
            strokeWidth={circleWidth}
            strokeLinecap="round"
            strokeDasharray={value + ', 100'}
            stroke={valueCircleColor}
            d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
          />
        )}
        {showScore && (
          <text
            x="18"
            y="20.35"
            fill="#1E1E31"
            fontSize="0.55em"
            textAnchor="middle"
            fontWeight="500"
          >
            {text}
          </text>
        )}
      </svg>
    </div>
  )
}

export default Chart
